import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CLIPBOARD: GlameraIconDefinition = {
  name: 'clipboard',
  viewBox: '0 0 24 24',
  svg: `
    <rect
      class="glm-clipboard-clip"
      x="8"
      y="2"
      width="8"
      height="4"
      rx="1"
      ry="1">
    </rect>
    <path
      class="glm-clipboard-body"
      d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2">
    </path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-clipboard-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './clipboard.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ClipboardIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CLIPBOARD;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
